module.exports = __webpack_public_path__ + "images/email/active-email-d84ff8abf24b274014ccb3ce54c27aa2.png";